/* eslint-disable */
import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import MaterialReactTable from 'material-react-table';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSnackbar } from 'notistack';
import EditIcon from '@mui/icons-material/Edit';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
// import {Container} from '@mui/material'
// import { PATH_DASHBOARD } from '../../../routes/paths';

import { Box, IconButton, Typography, Button, Paper, Container } from '@mui/material';
import axiosInstance from '../../../../utils/axios';
import Page from '../../../../components/Page';
// import { PATH_DASHBOARD } from '../../routes/paths';

import Iconify from '../../../../components/Iconify';
import HeaderBreadcrumbs from '../../../../components/HeaderBreadcrumbs';

import Dia from './Dia';

export default function PdfPod() {
  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();
  const handleCloseModal1 = () => {
    setIsModalOpen1(false)
};
  const [isModalOpen1, setIsModalOpen1] = React.useState(false);

  const handleOpenModal1 = () => {
    console.log('');
    // setCommentView(report?.report);
    setIsModalOpen1(true);
  };
  const [Data, setdata] = React.useState([]);
  const [loader, setloader] = React.useState(false);
  // console.log(Data, 'Data');
  const GetAllAdmin = () => {
    setloader(true)
    axiosInstance
      .get('admin/podreports')
      .then((response) => {
        if (response.data.podReports) {
          // console.log(response?.data);
          setdata(response?.data?.podReports);
          setloader(false)
          // console.log(response, 'resp');
        }
      })
      .catch((error) => {
        console.error(error);
        setloader(false)
      });
  };
  React.useEffect(() => {
    GetAllAdmin();
  }, []);
  async function handleDelete(rowdata) {
    // console.log(rowdata);
    try {
      await axiosInstance.delete(`admin/podreports/${rowdata}`).then((response) => {
        if (response?.data?.message === 'Deleted successfully') {
          enqueueSnackbar(response?.data?.message);
          GetAllAdmin();
        }
      });
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: 'error',
      });
      console.error(error);
    }
  }
  const columns = React.useMemo(
    () =>[
        {
          accessorKey: 'id',
          header: 'ID',
          size: 10,
        },
        {
          accessorKey: 'transporterId',
          header: 'Transporter ID',
          size: 20,
        },
        {
          accessorKey: 'employee_name',
          header: 'Employee Name',
          size: 20,
        },
        {
          accessorKey: 'transporter_id',
          header: 'Transporter ID',
          size: 20,
        },
        {
          accessorKey: 'opportunities',
          header: 'Opportunities',
          size: 20,
        },
        {
          accessorKey: 'success',
          header: 'Success',
          size: 20,
        },
        {
          accessorKey: 'bypass',
          header: 'By Pass',
          size: 20,
        },
        {
          accessorKey: 'rejects',
          header: 'Rejects',
          size: 20,
        },
        {
          accessorKey: 'blurry_photo',
          header: 'Blurry Photo',
          size: 20,
        },
        {
          accessorKey: 'human_in_the_picture',
          header: 'Human In The Picture',
          size: 20,
        },
        {
          accessorKey: 'no_package_detected',
          header: 'No Package Detected',
          size: 20,
        },
        {
          accessorKey: 'package_in_car',
          header: 'Package In Car',
          size: 20,
        },
        {
          accessorKey: 'package_in_hand',
          header: 'Package In Hand',
          size: 20,
        },
        {
          accessorKey: 'package_not_clearly_visible',
          header: 'Package Not Clearly Visible',
          size: 20,
        },
        {
          accessorKey: 'package_too_close',
          header: 'Package Too Close',
          size: 20,
        },
        {
          accessorKey: 'photo_too_dark',
          header: 'Photo Too Dark',
          size: 20,
        },
        {
          accessorKey: 'other',
          header: 'Other',
          size: 20,
        },
        {
          accessorKey: 'week',
          header: 'Week',
          size: 20,
        },
        
   
        {
            accessorKey: 'actions',
            header: 'Actions',
            size: 10,
            Cell: ({ row }) => (
              <Box>
             
                <IconButton
                  color="error"
                  sx={{
                    border: '1px solid',
                    borderColor: 'error.main',
                  }}
                  onClick={() => {
                    handleDelete(row.original.id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ),
          },
      ]
,      
    []
  );
  
  const data = [
    {
      id: 1,
      associateName: 'John Doe',
      transporterID: '12345',
      driverID: '67890',
      phoneNumber: '123-456-7890',
      email: 'john@example.com',
      startDate: '2022-01-01',
      status: 'Active',
      CDV: 'Yes',
      stepVan: 'No',
      electricVehicle: 'Yes',
      preferredVehicle1: 'Toyota Camry',
      preferredVehicle2: 'Honda Accord',
      preferredVehicle3: 'Tesla Model S',
    },
    {
      id: 2,
      associateName: 'Jane Smith',
      transporterID: '54321',
      driverID: '09876',
      phoneNumber: '987-654-3210',
      email: 'jane@example.com',
      startDate: '2022-02-01',
      status: 'Inactive',
      CDV: 'No',
      stepVan: 'Yes',
      electricVehicle: 'No',
      preferredVehicle1: 'Ford Fusion',
      preferredVehicle2: 'Chevrolet Malibu',
      preferredVehicle3: 'N/A',
    },
    // Add more data as needed
  ];
  
  const [tableData, setTableData] = React.useState([]);


  React.useEffect(() => {
    setTableData(data);
  }, []);

  return (
<Page title="Pod Report">
  <Container maxWidth="lg">
    <HeaderBreadcrumbs
      heading="Pot Report"
      links={[{ name: '', href: '' }]}
      action={
        <>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            component={RouterLink}
            to={''}
            onClick={handleOpenModal1}
            style={{ marginRight: '8px' }} // Add margin to the right for spacing
          >
            Import Pdf
          </Button>
{/*           
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            component={RouterLink}
            to={PATH_DASHBOARD.element.addelement}
          >
            Vehicle
          </Button> */}
        </>
      }
    />
    <MaterialReactTable
    state={{loader ,showSkeletons:loader}}
      columns={columns}
      data={Data}
      enableRowActions={false}
    />
  </Container>
<Dia handleCloseModal1={handleCloseModal1} isModalOpen1={isModalOpen1} GetAllAdmin={GetAllAdmin}/>

</Page>

  );
}
